import React, { useState, useCallback, useEffect } from 'react';
import { PopularPackage } from '../hs-grad/popularPackage';
import { Breadcrumb } from '../breadcrumb';
import GradPackageTabs from '../hs-grad/gradPackageTabs';
import HeroBanner from '../hs-grad/heroBanner';
import { TitleBar } from '../packageBrowseTitle';
import {
	BREADCRUMB,
	HELPBUTTON,
	HEROBANNER,
	PACKAGEGRID,
	PAGETITLE,
	POPULARPACKAGE,
} from '../../constants/rootElements';
import { HelpButton } from "../help";
import { gaPackageBrowsePageLoad } from '../../util/googleAnalytics';
import { renderPromoMessages } from '../promoMessages';
import { useFeeAlertInjectionScript } from "../../hooks/useFeeAlertInjectionScript";

export const COLGradAnnouncements = (props) => {
	const { packageBrowseData, pageContentData, affiliationData } = props.appData;
	const [gradPackageGroupData, setGradPackageGroupData] = useState({});
	const [popularPackageItems, setPopularPackageItems] = useState([]);
	const [promoMessages, setPromoMessages] = useState([]);
	const [popularPackageName, setPopularPackageName] = useState('');
	const [popularPackageRepMessage, setPopularPackageRepMessage] = useState('');
	const [loadGrid, setLoadGrid] = useState(false)
	const [feeAlertRequestData, setFeeAlertRequestData] = useState(null)
	useFeeAlertInjectionScript(feeAlertRequestData)

	const PBBreadcrumb = pageContentData?.find(
		(data) => data.contentType === 'Navigation'
	);
	const HsHeroBanner = pageContentData?.find(
		(data) => data.contentType === 'GradPackageBrowseBanner'
	);
	const HsPopularPackage = pageContentData?.find(
		(data) => data.contentType === 'MascotPackage'
	);
	const HsPackages = pageContentData?.find(
		(data) => data.contentType === 'Packages'
	);
	const HsPageTitle = pageContentData?.find(
		(data) => data.contentType === 'ProductBrowseTitle'
	);
	const GradAnncPaymentPromo = pageContentData?.find(
		(data) => data.contentType === 'PaymentPromo'
	);
	const ProductBrowsePromoMsg = Boolean(
		pageContentData?.find(
			(data) => data.contentType === 'ProductBrowsePromoMsg'
		)
	);

	const handleScroll = () => {
        setLoadGrid(true);
        removeScrollEvent();
    };
    
    const addScrollEvent = () => {
        window.addEventListener('scroll', handleScroll);
    }

    const removeScrollEvent = () => {
        window.removeEventListener('scroll', handleScroll);
    }

    useEffect(()=>{
        if(document.body.clientWidth<1980) {
            addScrollEvent();
        } else {
            setLoadGrid(true);
        }
        return () => removeScrollEvent();
    },[])

	useEffect(() => {
		if (Object.keys(packageBrowseData)?.length > 0) {
			Object.keys(packageBrowseData).forEach((hsData) => {
                if(hsData === 'metaData') return;

				if (hsData.includes(affiliationData?.affiliateId)) {
					Object.keys(packageBrowseData[hsData].productGroups)?.length > 0 &&
						Object.keys(packageBrowseData[hsData].productGroups).forEach(
							(groupData) => {
								if (
									packageBrowseData[hsData].productGroups[
										groupData
									]?.groupOsr?.includes(HsPackages?.ctaCheck?.groupOsr)
								) {
									setGradPackageGroupData(
										packageBrowseData[hsData].productGroups[groupData]
									);
									setPromoMessages(
										packageBrowseData[hsData].promoMessages
									);
									setFeeAlertRequestData({
										containerSelector: '#promoMsg',
										customerId: packageBrowseData.metaData.customerNumber,
										catalogOsr: packageBrowseData[hsData].catalogOsr,
									})
									if (
										packageBrowseData[hsData].productGroups[groupData].products
											?.length > 0
									) {
										const productOsr =
											packageBrowseData[hsData].productGroups[groupData]
												.products[0]?.productOsr;
										setPopularPackageName(
											packageBrowseData[hsData].productGroups[groupData]
												.products[0]?.displayName
										);
										setPopularPackageRepMessage(
											packageBrowseData[hsData].productGroups[groupData]
												.products[0]?.repMessage
										);
										const packageOsrItems = [];
										packageBrowseData[hsData].productGroups[groupData]
											.packageItems?.length > 0 &&
											packageBrowseData[hsData].productGroups[
												groupData
											].packageItems.map((packages) => {
												if(packages.displayName !== "freeProducts") {
													packages.packageProductAvailability.map((prodAvail) => {
														if (prodAvail.packageOsr === productOsr) {
															packageOsrItems.push(packages);
														}
														return true;
													});
												}
												setPopularPackageItems(packageOsrItems);
												return true;
											});
									}
								}
								return true;
							}
						);
				}
			});
		}
	}, [packageBrowseData, HsPackages?.ctaCheck?.groupOsr, affiliationData?.affiliateId]);

	const getBreadcrumb = useCallback(() => {
		BREADCRUMB.render(<Breadcrumb pbData={gradPackageGroupData} />);
	}, [gradPackageGroupData]);

	const getPromoMsg = useCallback(() => {
		renderPromoMessages(promoMessages)
	}, [promoMessages]);

	const getPopularPackage = useCallback(() => {
		POPULARPACKAGE.render(
			<PopularPackage
				firstPackageName={popularPackageName}
				packageItems={popularPackageItems}
				hsPopularPackage={HsPopularPackage}
				isDegreeSelected={true}
			/>
		);
	}, [popularPackageName, popularPackageItems, HsPopularPackage]);

	const getHeroBanner = useCallback(() => {
		HEROBANNER.render(
			<HeroBanner
				pageContentData={HsHeroBanner}
				hsPaymentPromo={GradAnncPaymentPromo}
				packageGroupData={gradPackageGroupData}
				repMessage={popularPackageRepMessage}
				firstPackageName={popularPackageName}
			/>
		);
	}, [
		HsHeroBanner,
		GradAnncPaymentPromo,
		gradPackageGroupData,
		popularPackageRepMessage,
		popularPackageName,
	]);

	const getGradPackage = useCallback(() => {
		gradPackageGroupData?.packageItems?.length > 0 &&
			gradPackageGroupData?.products?.length > 0 &&
			PACKAGEGRID.render(
					<GradPackageTabs
						packageList={gradPackageGroupData?.packageItems?.filter(
							(obj) => obj.packageProductAvailability?.length > 0
						)}
						productList={gradPackageGroupData?.products}
						pageContentData={HsPackages}
						altImage={HsPopularPackage?.imageUrl}
						isDegreeSelected={true}
					/>
			);
	}, [gradPackageGroupData, HsPackages]);

	const getTitleBar = useCallback(() => {
		PAGETITLE.render(
			<TitleBar pageContent={HsPageTitle} affiliationData={affiliationData} />
		);
	}, [HsPageTitle, affiliationData]);

	const getHelpButton = useCallback(() => {
		HELPBUTTON.render(<HelpButton />);
	}, [])

	useEffect(()=>{
		gaPackageBrowsePageLoad();
	},[])

	return (
		<div className='container-fluid'>
			{HsPageTitle && Object.keys(HsPageTitle)?.length > 0 && getTitleBar()}
			{ProductBrowsePromoMsg && promoMessages?.length > 0 && getPromoMsg()}
			{PBBreadcrumb &&
				gradPackageGroupData &&
				Object.keys(gradPackageGroupData)?.length > 0 &&
				getBreadcrumb()}
			{HsHeroBanner && getHeroBanner()}
			{HsPopularPackage && getPopularPackage()}
			{HsPackages && loadGrid && getGradPackage()}
			{getHelpButton()}
		</div>
	);
};